import { render, staticRenderFns } from "./TipoMeritoPage.vue?vue&type=template&id=690ba69b"
import script from "./TipoMeritoPage.js?vue&type=script&lang=js&external"
export * from "./TipoMeritoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports